export const FeatureFlags = {
  AIAssistant: 'aiAssistant',
  AIAssistantSelectModels: 'aiAssistantSelectModels',
  AIGeneratorsIndustryBriefing: 'aiGeneratorsIndustryBriefing',
  AIGeneratorsLinkedinAIPrompt: 'aiGeneratorsLinkedinAIPrompt',
  AIPresentationMakerV2Endpoints: 'aiPresentationMakerV2Endpoints',
  AIProspectingAssistant: 'aiProspectingAssistant',
  AIRoleplay: 'aiRoleplay',
  AIRoleplayCreationFromList: 'aiRoleplayCreationFromList',
  ActivityDrawerInTablesCC: 'activityDrawerInTablesCC',
  ActivityOutcomeFieldsInForm: 'activityOutcomeFieldsInForm',
  AssitantRegionalDirectorsOnBehalfSendoutCreation:
    'assitantRegionalDirectorsOnBehalfSendoutCreation',
  AssociatedCompaniesTree: 'associatedCompaniesTree',
  BulkEmailAI: 'bulkEmailAI',
  BulkEmailAIRecruiting: 'bulkEmailAIRecruiting',
  BulkEmailListItemCardAILabel: 'AILabelOnBulkEmailItemCards',
  BulkEmailNewDashboardStats: 'newBulkDashboardStats',
  BulkEmailSequences: 'bulkEmailSequences',
  BulkEmailStatsQuickView: 'bulkemail-quickview',
  BulkShowEmailVariant: 'bulkShowEmailVariant',
  BulkSmartTagOnEmailBody: 'smartTagOnEmailBody',
  BulkSmartTagOnSubject: 'smartTagOnSubject',
  BulkStatsTablesActions: 'bulkStatsTablesActions',
  CandidateKeywordTags: 'candidateKeywordTags',
  CandidateMatchMaking: 'candidateMatchMaking',
  CandidateMatchMakingByContact: 'candidateMatchMakingByContact',
  CandidateMatchMakingByJobOrder: 'candidateMatchMakingByJobOrder',
  CandidatesKeywordsFromApplicantUrl: 'candidatesKeywordsFromApplicantUrl',
  CandidatesMultiplePhones: 'candidatesMultiplePhones',
  CandidatesPresentationMaker: 'candidatesPresentationMaker',
  CandidatesSavedSearches: 'candidatesSavedSearches',
  CandidatesTabMultiplePhones: 'candidatesTabMultiplePhones',
  CategoryFilesSendout: 'categoryFilesSendout',
  CategoryFilesSendoutDebrief: 'categoryFilesSendoutDebrief',
  ClaimAccountabilityCandidate: 'claimAccountabilityCandidate',
  ClaimAccountabilityCompany: 'claimAccountabilityCompany',
  ClaimAccountabilityJobOrder: 'claimAccountabilityJobOrder',
  CommandCenterCommissionsBoard: 'commandCenterCommissionsBoard',
  CommandCenterDominateActiveTab: 'commandCenterDominateActiveTab',
  CommandCenterDominateEstimatedCommissions: 'commandCenterDominateEstimatedCommissions',
  CommandCenterDrillDown: 'commandCenterDrillDown',
  CommandCenterFallOffsBoard: 'commandCenterFallOffsBoard',
  CommandCenterPDA: 'commandCenterPDA',
  CommandCenterProductionBoardPage: 'commandCenterProductionBoardPage',
  CommandCenterProductionBoardTracking: 'commandCenterProductionBoardTracking',
  CommandCenterShowVerification: 'commandCenterShowVerification',
  CompaniesHeadquarterColumn: 'companiesHeadquarterColumn',
  CompaniesKeywordTags: 'companiesKeywordTags',
  CompaniesMultiplePhones: 'companiesMultiplePhones',
  CompaniesSalesTab: 'companiesSalesTab',
  CompaniesSavedSearches: 'companiesSavedSearches',
  CompaniesTargetPriority: 'companiesTargetPriority',
  ContactKeywordTags: 'contactKeywordTags',
  Contacts: 'contacts',
  ContactsDataSheetTab: 'contactsDataSheetTab',
  ContactsMultiplePhones: 'contactsMultiplePhones',
  ContactsSavedSearches: 'contactsSavedSearches',
  ConvertLegacyPhones: 'convertLegacyPhones',
  ConvertedContacts: 'redirectConvertedContacts',
  DailyPlan: 'dailyPlan',
  DailyPlanAddTaskFromProfile: 'dailyPlanAddTaskFromProfile',
  DailyPlanAddTasksFromTable: 'dailyPlanAddTasksFromTable',
  DailyPlanArchiveTasks: 'dailyPlanArchiveTasks',
  DailyPlanBulkReschedule: 'dailyPlanBulkReschedule',
  DashboardFeeAgreements: 'dashboardFA',
  DashboardSendoutLeaders: 'dashboardsendoutleaders',
  DashboardSendoutMetrics: 'dashboardsendoutmetrics',
  DashboardToolsUsageReport: 'dashboardtoolsusagereport',
  DashboardToolsUsageReportV2: 'dashboardtoolsusagereportV2',
  DisableQuickViewSwitch: 'quickViewSwitch',
  Drafts: 'drafts',
  EmailValidationColumn: 'emailValidationColumn',
  EmailVerdictV2: 'emailVerdictV2',
  EmailWithValidationColumnCandidates: 'emailWithValidationColumnCandidates',
  EmailWithValidationColumnNames: 'emailWithValidationColumnNames',
  EmailWithValidationColumnSearchProjectPreviews: 'emailWithValidationColumnSearchProjectPreviews',
  EmployeesMultiplePhones: 'employeesMultiplePhones',
  EnableActionsTab: 'enableNotesActionsTab',
  EnableQuickViewNavigation: 'enableQuickViewNavigation',
  EnableRemoveInBulkTables: 'enableRemoveInBulkTables',
  ExpandableTables: 'expandableTables',
  ExternalFeeAgreement: 'externalFA',
  FeeAgreement: 'feeagreement',
  FeeAgreementsSplitPayments: 'fa-split-payments',
  FeedbackNotes: 'feedbackNotesDrawer',
  FeedbackNotesImagesSuport: 'feedbackNotesImagesSupport',
  FeedbackNotesSaveInEmployeeFile: 'feedbackNotesSaveInEmployeeFile',
  FileManager: 'fileManager',
  FilterByActivitiesInSearchProjects: 'filterByActivitiesInSearchProjects',
  FilterByBusinessInvolvement: 'filterByBusinessInvolvement',
  FilterByBusinessInvolvementSearchProjects: 'filterByBusinessInvolvementSearchProjects',
  FilterByCandidateAccountableOfHotSheet: 'filterByCandidateAccountableOfHotSheet',
  FilterByCandidateActivities: 'filterByCandidateActivities',
  FilterByCompanyActivities: 'filterByCompanyActivities',
  FilterByCompanyLegalName: 'filterByCompanyLegalName',
  FilterByContactActivities: 'filterByContactActivities',
  FilterByFeeAgreementPaymentScheme: 'filterByFeeAgreementPaymentScheme',
  FilterByJobOrderAccountableOfHotSheet: 'filterByJobOrderAccountableOfHotSheet',
  FilterByJobOrderActivities: 'filterByJobOrderActivities',
  FilterByLinkedInUrl: 'filterByLinkedInUrl',
  FilterByNumberOfContactsRange: 'filterByNumberOfContactsRange',
  FilterByNumberOfEmployeesRange: 'filterByNumberOfEmployeesRange',
  FilterByRevenueRange: 'filterByRevenueRange',
  FilterBySubStatus: 'filterBySubStatus',
  FollowUpTasks: 'followUpTasks',
  FreeGameButtons: 'FreeGameButtons',
  HaFeeAgreementTab: 'haFeeAgreementTab',
  HaJobOrderTab: 'haJobOrderTab',
  HaNameSubStatusEdition: 'haNameSubStatusEdition',
  HaPlacementsTab: 'haPlacementsTab',
  HiringAuthoritiesMultiplePhones: 'hiringAuthoritiesMultiplePhones',
  HiringExtendedLocationSearch: 'hiringExtendedLocationSearch',
  Home: 'newHome',
  HomeMultipleRegions: 'homeMultipleRegions',
  IndustriesViewer: 'industriesViewer',
  IndustryEmailBCCSendout: 'industryEmailBCCSendout',
  InventoryListPersistDateRange: 'inventoryListPersistDateRange',
  JobOrderColumnMultipleHA: 'jobOrderColumnMultipleHA',
  JobOrderColumnsHAProfile: 'jobOrderColumnsHAProfile',
  JobOrderDataSheetFlow: 'jobOrderDataSheetFlow',
  JobOrderJobDescription: 'jobOrderJobDescription',
  JobOrderKeywordTags: 'jobOrderKeywordTags',
  JobOrderMatchMaking: 'jobOrderMatchMaking',
  JobOrderMatchMakingByApplicant: 'jobOrderMatchMakingByApplicant',
  JobOrderMatchMakingByCandidate: 'jobOrderMatchMakingByCandidate',
  JobOrderMatchMakingByContact: 'jobOrderMatchMakingByContact',
  JobOrderPresentationMaker: 'jobOrderPresentationMaker',
  JobOrderSavedSearches: 'jobOrderSavedSearches',
  KeywordPickerSplitByComma: 'keywordPickerSplitByComma',
  KeywordSearch: 'keywordsearch',
  LinkCompanies: 'linkCompanies',
  LogRocket: 'logrocket',
  MapSubspecialtyFilter: 'map_subspecialty_filter',
  MenuNavBar: 'menunavbar',
  MessageCenter: 'messageCenter',
  MessageCenterDrawerChat: 'messageCenterDrawerChat',
  MessageCenterFilters: 'messageCenterFilters',
  MessageCenterNotifications: 'messageCenterNotifications',
  MessageCenterSelectMessages: 'messageCenterSelectMessages',
  MessageCenterSendToUnsavedContact: 'messageCenterSendToUnsavedContact',
  MessageCenterTemplates: 'messageCenterTemplates',
  MultipleActivitiesFromList: 'multipleActivitiesFromList',
  MultipleKeywordsFromList: 'multipleKeywordsFromList',
  MultipleNotesFromList: 'multipleNotesFromList',
  MultiplePhonesColumn: 'multiplePhonesColumn',
  MultiplePhonesWithCommunicationActions: 'multiplePhonesWithCommunicationActions',
  MutiplePhonesListingTags: 'mutiplePhonesListingTags',
  NewCandidateFromContact: 'newCandidateFromContact',
  NewCandidateIncludesContactDataSheet: 'newCandidateIncludesContactDataSheet',
  NewCandidateTalentPoolValidation: 'newCandidateTalentPoolValidation',
  NewCandidateV2: 'newCandidateV2',
  NewHiringAuthorityTabs: 'newHiringAuthorityTabs',
  NoHireLetter: 'noHireLetter',
  Notifications: 'notifications',
  OpenToRelocationFilter: 'openToRelocationFilter',
  OptOutFilter: 'optOutFilter',
  OtherEmailValidationProfiles: 'otherEmailValidationProfiles',
  PersonalEmailVerdictFilter: 'personalEmailVerdictFilter',
  PhoneDashboardTotalCalls: 'phoneDashboardTotalCalls',
  PilDescriptions: 'pilDescriptions',
  PlacementCollections: 'placement-collections',
  PlacementDeletePermanently: 'placementDeletePermanently',
  PlacementPaymentsFromNetsuite: 'placement-paymets-from-netsuite',
  PlacementRequestFeeOrGuaranteeChanges: 'placementRequestFeeOrGuaranteeChanges',
  PlacementSavedSearches: 'placementSavedSearches',
  PlacementWithAssignmentDataSheet: 'placement-data-sheet',
  PlacementWithEstimates: 'placement-estimates',
  PlacementWithReferences: 'placement-references',
  ProfileLayout: 'profileLayout',
  ProfileNavigationControls: 'profileNavigationControls',
  QuickEntry: 'quickEntry',
  RecruiterProfileNotes: 'recruiterProfileNotes',
  ReferenceCheckAISummary: 'referenceCheckAISummary',
  ReferenceCheckDownload: 'referenceCheckDownload',
  RequestDoNotContactFromProfile: 'requestDoNotContactFromProfile',
  RequestDoNotEngageFromProfile: 'requestDoNotEngageFromProfile',
  ResendEmailHiringAuthoritySendout: 'resendEmailHiringAuthoritySendout',
  ResumeSearch: 'resumeSearch',
  SavedSearchesDate: 'savedSearchesDate',
  SearchProjectPreviewMultiplePhones: 'searchProjectPreviewMultiplePhones',
  SearchProjectsArchiveMultiple: 'archiveMultipleSearchProjects',
  SearchProjectsChangeOwner: 'changeSearchProjectOwner',
  SearchProjectsFolders: 'searchProjectsFolders',
  SearchProjectsMasterListFields: 'masterListFields',
  SendBulkViaOutlook: 'sendBulkViaOutlook',
  SendoutDuplicates: 'sendoutDuplicates',
  SendoutStatusReasonsFilter: 'sendoutStatusReasonsFilter',
  Sendouts: 'sendouts',
  SendoutsV2: 'sendoutsV2',
  SendoutsChannelPartner: 'sendoutsChannelPartner',
  SendoutsInterviewDetailsActions: 'sendoutsInterviewDetailsActions',
  SendoutsSavedSearches: 'sendoutsSavedSearches',
  SendoverHAReminder: 'sendoverHAReminder',
  SharedSavedSearches: 'sharedSavedSearches',
  SidebarV2: 'sidebarV2',
  SigningBackupService: 'signingBackup',
  SpecificPILLocation: 'specificPILLocation',
  SupportActivity: 'supportActivity',
  TalentPoolLink: 'talentPoolLink',
  UrgencyVerification: 'urgencyVerification',
  WebsiteFilter: 'websiteFilter'
};
